import { Anchor, Row, Col, Flex } from 'antd';
import React, { } from 'react';
import { styled } from 'styled-components';
import { PageSection, PageTitle, PageContent } from '../../styles/global/Pages.styled';
import { Widget } from "../Global/Atomics/Widget";
import { eventsDataDonut, eventsDataBignumbers, eventsData } from "../../utils/dummydata";
import { Text } from '../Global/Atomics/Text';
import { useTranslation } from 'react-i18next';

import { DatePicker } from 'antd';
import { useGlobalFilterContext } from '../../contexts/GlobalFilterProvider';
const { RangePicker } = DatePicker;

// Destructure components from Ant Design
const { Link } = Anchor;

// Define a styled RangePicker component using styled-components
const CustomDatePicker = styled(RangePicker)`
  width: 350px;
  height: 56px;

  // Style the SVG icon within the RangePicker suffix
  .ant-picker-suffix svg {
    fill: #0076A8; 
  }
`;

// Define a functional component named Events
export const Events = () => {
  // Retrieve global filter content and translation function from context and i18n
  const { mapFilterContent } = useGlobalFilterContext();
  const { t } = useTranslation();

  // Render the Events component
  return (
    // Render the content of the page
    <PageContent>
      {/* Render the first section with a specific background color */}
      <PageSection $backgroundColor='neutral-1' >
        {/* Use Flex component to align elements and create space between them */}
        <Flex align="center" justify="space-between">
          {/* Render the title of the section */}
          <PageTitle>
            <div className="title">
              {/* Render a text component with specific styles and translated text */}
              <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>{t('events')}</Text>
            </div>
          </PageTitle>
        </Flex>
      </PageSection>

      {/* Render another section with a different background color */}
      <PageSection $backgroundColor='neutral-1' className='first-section'>
        {/* Use Grid layout to organize widgets */}
        <Row gutter={[32, 32]}>
          {/* Render a column with a specific width and a widget inside it */}
          <Col span={8}>
            <Widget data={eventsDataDonut} filters={mapFilterContent} />
          </Col>
          {/* Render another column with a different width */}
          <Col span={16}>
            {/* Render a row inside the column to further organize widgets */}
            <Row gutter={[32, 32]}>
              {/* Map through an array of data and render a widget for each item */}
              {eventsDataBignumbers.map((item, index) => (
                <Col key={index} span={item.cols}>
                  <Widget data={item} filters={mapFilterContent} />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </PageSection>

      {/* Render another section with a white background */}
      <PageSection $backgroundColor='white'>
        {/* Render a row to organize widgets */}
        <Row gutter={[32, 32]}>
          <Col span={24}>
            {/* Render a row inside the column to further organize widgets */}
            <Row gutter={[32, 32]}>
              {/* Map through an array of data and render a widget for each item */}
              {eventsData?.map((item, index) => {
                  return (<Col span={24} key={index}>
                    <Widget data={item} filters={mapFilterContent} />
                  </Col>)
              }
              )}
            </Row>
          </Col>
        </Row>
      </PageSection>
    </PageContent>
  );
}
